export default class LoadingScreenEvent {
    constructor(type) {
        this._type = type;
    }

    get type() {
        return this._type;
    }
}

LoadingScreenEvent.SHOW_REQUEST = "LoadingScreenEvent.SHOW_REQUEST";
LoadingScreenEvent.HIDE_REQUEST = "LoadingScreenEvent.HIDE_REQUEST";
LoadingScreenEvent.LOADING_ANIMATION_FINISHED = "LoadingScreenEvent.LOADING_ANIMATION_FINISHED";